import { get } from "../services/apiService";

export interface UserActivityDayDTO {
  date: string; // YYYY-MM-DD
  firstSeenAt: string; // ISO datetime
  lastSeenAt: string; // ISO datetime
  hitCount: number;
}

export interface UserActivitySummaryDTO {
  userId: number;
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
  activeDays: number;
  days: UserActivityDayDTO[];
}

interface ApiResponse<T> {
  status: number;
  message?: string;
  success: boolean;
  timestamp?: string;
  data: T;
  errors?: any;
}

export async function getUserActivitySummary(params: {
  userId: number;
  from?: string;
  to?: string;
  defaultDays?: number;
}): Promise<UserActivitySummaryDTO> {
  const { userId, from, to, defaultDays } = params;

  const qs = new URLSearchParams();
  if (from) qs.set("from", from);
  if (to) qs.set("to", to);
  if (!from && typeof defaultDays === "number") {
    qs.set("defaultDays", String(defaultDays));
  }

  const url = `/api/admin/activity/users/${encodeURIComponent(String(userId))}${
    qs.toString() ? `?${qs.toString()}` : ""
  }`;

  const res = (await get(url)) as ApiResponse<UserActivitySummaryDTO>;
  if (!res?.success) {
    throw new Error(res?.message || "Failed to load user activity.");
  }
  return res.data;
}

